import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "state-tab-layout" }
const _hoisted_2 = {
  key: 0,
  class: "diagram-column"
}
const _hoisted_3 = { class: "properties-column" }
const _hoisted_4 = { class: "state-section ai-state-section" }
const _hoisted_5 = { class: "section-header" }
const _hoisted_6 = { class: "state-tree" }
const _hoisted_7 = { class: "tree-item" }
const _hoisted_8 = { class: "tree-item" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  width: "12",
  height: "12"
}
const _hoisted_11 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  width: "12",
  height: "12"
}
const _hoisted_12 = { class: "tree-item" }
const _hoisted_13 = ["href", "title"]
const _hoisted_14 = {
  key: 1,
  class: "value url-value null"
}
const _hoisted_15 = { class: "tree-item" }
const _hoisted_16 = { class: "state-section" }
const _hoisted_17 = { class: "section-header" }
const _hoisted_18 = { class: "state-tree" }
const _hoisted_19 = { class: "tree-item" }
const _hoisted_20 = ["title"]
const _hoisted_21 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  width: "12",
  height: "12"
}
const _hoisted_22 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  width: "12",
  height: "12"
}
const _hoisted_23 = { class: "tree-item" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "tree-item" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "tree-item" }
const _hoisted_28 = { class: "state-section" }
const _hoisted_29 = { class: "section-header" }
const _hoisted_30 = { class: "state-tree" }
const _hoisted_31 = { class: "tree-item" }
const _hoisted_32 = { class: "value number" }
const _hoisted_33 = { class: "state-section" }
const _hoisted_34 = { class: "section-header" }
const _hoisted_35 = { class: "state-tree" }
const _hoisted_36 = { class: "tree-item" }
const _hoisted_37 = { class: "tree-item" }
const _hoisted_38 = { class: "state-section ui-state-section" }
const _hoisted_39 = { class: "section-header" }
const _hoisted_40 = { class: "state-tree" }
const _hoisted_41 = { class: "tree-item" }
const _hoisted_42 = { class: "tree-item" }
const _hoisted_43 = { class: "tree-item" }
const _hoisted_44 = { class: "tree-item" }
const _hoisted_45 = { class: "tree-item" }
const _hoisted_46 = { class: "tree-item" }
const _hoisted_47 = { class: "tree-item" }
const _hoisted_48 = { class: "state-section" }
const _hoisted_49 = { class: "section-header" }
const _hoisted_50 = { class: "state-tree" }
const _hoisted_51 = { class: "tree-item" }
const _hoisted_52 = { class: "tree-item" }
const _hoisted_53 = { class: "tree-item" }
const _hoisted_54 = { class: "tree-item" }
const _hoisted_55 = { class: "value number" }
const _hoisted_56 = { class: "state-section" }
const _hoisted_57 = { class: "section-header" }
const _hoisted_58 = { class: "state-tree" }
const _hoisted_59 = { class: "tree-item" }
const _hoisted_60 = ["title"]
const _hoisted_61 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  width: "12",
  height: "12"
}
const _hoisted_62 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  width: "12",
  height: "12"
}
const _hoisted_63 = { class: "tree-item" }
const _hoisted_64 = { class: "state-section" }
const _hoisted_65 = { class: "section-header" }
const _hoisted_66 = { class: "state-tree" }
const _hoisted_67 = { class: "tree-item" }
const _hoisted_68 = { class: "tree-item" }
const _hoisted_69 = { class: "header-right" }
const _hoisted_70 = {
  key: 0,
  class: "detached-badge"
}
const _hoisted_71 = {
  key: 1,
  class: "history-count"
}
const _hoisted_72 = ["title"]
const _hoisted_73 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  width: "12",
  height: "12"
}
const _hoisted_74 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  width: "12",
  height: "12"
}
const _hoisted_75 = {
  key: 0,
  class: "history-content"
}
const _hoisted_76 = {
  key: 0,
  class: "history-actions"
}
const _hoisted_77 = {
  key: 1,
  class: "history-empty"
}
const _hoisted_78 = {
  key: 2,
  class: "history-list"
}
const _hoisted_79 = { class: "entry-header" }
const _hoisted_80 = { class: "entry-source" }
const _hoisted_81 = { class: "entry-key" }
const _hoisted_82 = { class: "entry-time" }
const _hoisted_83 = { class: "entry-change" }
const _hoisted_84 = { class: "old-value" }
const _hoisted_85 = { class: "new-value" }

import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import { useRecoveryMode } from "@/composables/useRecoveryMode";
import { useDevSettings } from "@/composables/useDevSettings";
import { useStateMachine, type AIAssistantState } from "@/composables/useStateMachine";
import { useDevPanel } from "@/composables/useDevPanel";
import { useStateHistory } from "@/composables/useStateHistory";
import StateDiagram from "../StateDiagram.vue";

// AI Assistant State Machine (singleton)

export default /*@__PURE__*/_defineComponent({
  __name: 'StateTab',
  setup(__props) {

const machine = useStateMachine();

// Dev Panel state (for expanded mode)
const { isExpanded } = useDevPanel();

// Track previous state for diagram transitions
const previousState = ref<AIAssistantState | null>(null);

// Watch state changes to track previous state
watch(
  () => machine.state,
  (newState, oldState) => {
    if (oldState) {
      previousState.value = oldState as AIAssistantState;
    }
  }
);

// Computed values for template (simplified - no nested reviewStatus)
const aiState = computed(() => machine.state);
const aiSessionData = computed(() => machine.sessionData);
const aiRecorderUrl = computed(() => machine.recorderUrl);
const aiLockedSessionId = computed(() => machine.lockedSessionId);

const getStateStatusClass = computed(() => {
  switch (machine.state) {
    case "idle":
      return "inactive";
    case "form_template_selection":
    case "device_selection":
      return "active";
    case "recording":
      return "warning";
    case "processing":
      return "warning";
    case "review_ready":
      return "active";
    case "error":
      return "warning";
    default:
      return "inactive";
  }
});

const truncateUrl = (url?: string) => {
  if (!url) return null;
  if (url.length > 40) return url.slice(0, 40) + "...";
  return url;
};

// Copy to clipboard functionality
const copiedField = ref<string | null>(null);

const copyToClipboard = async (text: string, field: string) => {
  try {
    await navigator.clipboard.writeText(text);
    copiedField.value = field;
    setTimeout(() => {
      copiedField.value = null;
    }, 1500);
  } catch (err) {
    console.error("Failed to copy:", err);
  }
};

// Recovery Mode
const { isInRecoveryMode, lastKnownStatus, showRefreshButton, pollingFailCount } = useRecoveryMode();

// Session Lock (now from state machine)
const isLocked = computed(() => machine.lockedSessionId !== null);

// Dev Settings
const { settings } = useDevSettings();

// State History (shared composable)
const {
  stateHistory,
  isDetached,
  showHistory,
  addHistoryEntry,
  clearHistory,
  toggleDetach,
  formatHistoryTime,
  formatValue,
} = useStateHistory();

// Socket state (poll from window)
const socketConnected = ref(false);
const isReconnecting = ref(false);

// UI state - now using reactive refs from state machine directly
const uiDisplayMode = computed(() => machine.displayMode);
const uiIsMinimized = computed(() => machine.isUIMinimized);
const uiShowFab = computed(() => machine.showFab);
const uiRecorderVisible = computed(() => machine.isIn("recording") && machine.recorderVisible);
const uiPopoverVisible = computed(() => machine.isIn("review_ready", "processing"));
const uiProcessingModalVisible = computed(() => machine.isIn("processing") && machine.displayMode === "modal");
const uiReviewModalVisible = computed(() => machine.isIn("review_ready") && machine.displayMode === "modal");

const hasActiveDevSettings = computed(() => {
  return settings.value.simulateSocketDisconnect || settings.value.simulatePollingTimeout;
});

// Watch for State Machine changes (using refs for reactivity)
watch(machine.stateRef, (newVal, oldVal) => addHistoryEntry("StateMachine", "state", oldVal, newVal));

watch(
  () => machine.sessionDataRef.value?.recorderSessionId,
  (newVal, oldVal) => addHistoryEntry("StateMachine", "sessionId", oldVal, newVal)
);

watch(
  () => machine.recorderUrl,
  (newVal, oldVal) => addHistoryEntry("StateMachine", "recorderUrl", oldVal, newVal)
);

watch(
  () => machine.lockedSessionId,
  (newVal, oldVal) => addHistoryEntry("StateMachine", "lockedSessionId", oldVal, newVal)
);

watch(socketConnected, (newVal, oldVal) => addHistoryEntry("Socket", "connected", oldVal, newVal));

watch(isReconnecting, (newVal, oldVal) => addHistoryEntry("Socket", "reconnecting", oldVal, newVal));

watch(isInRecoveryMode, (newVal, oldVal) => addHistoryEntry("Recovery", "active", oldVal, newVal));

watch(lastKnownStatus, (newVal, oldVal) => addHistoryEntry("Recovery", "status", oldVal, newVal));

watch(showRefreshButton, (newVal, oldVal) => addHistoryEntry("Recovery", "showRefresh", oldVal, newVal));

// Session lock changes tracked via StateMachine watcher above

watch(
  () => settings.value.simulateSocketDisconnect,
  (newVal, oldVal) => addHistoryEntry("DevSettings", "socketDisconnect", oldVal, newVal)
);

watch(
  () => settings.value.simulatePollingTimeout,
  (newVal, oldVal) => addHistoryEntry("DevSettings", "pollingTimeout", oldVal, newVal)
);

// Watch UI state changes (using reactive refs from state machine)
watch(machine.displayModeRef, (newVal, oldVal) => addHistoryEntry("UI", "displayMode", oldVal, newVal));
watch(machine.minimizedRef, (newVal, oldVal) => addHistoryEntry("UI", "minimized", oldVal, newVal));
watch(machine.recorderVisibleRef, (newVal, oldVal) => addHistoryEntry("UI", "recorderVisible", oldVal, newVal));

// Poll socket state only (UI state now uses reactive refs from state machine)
let pollInterval: ReturnType<typeof setInterval> | null = null;

const pollSocketState = () => {
  // Try to get socket state from window (if exposed by useWebSocket)
  const win = window as unknown as {
    __aiAssistantSocketState?: { connected: boolean; reconnecting: boolean };
  };
  if (win.__aiAssistantSocketState) {
    socketConnected.value = win.__aiAssistantSocketState.connected || false;
    isReconnecting.value = win.__aiAssistantSocketState.reconnecting || false;
  }
};

onMounted(() => {
  pollSocketState();
  pollInterval = setInterval(pollSocketState, 1000); // Socket state polling
});

onUnmounted(() => {
  if (pollInterval) {
    clearInterval(pollInterval);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["state-tab", { expanded: _unref(isExpanded) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isExpanded))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "diagram-header" }, [
              _createElementVNode("span", { class: "diagram-title" }, "State Flow")
            ], -1)),
            _createVNode(StateDiagram, {
              "current-state": aiState.value,
              "previous-state": previousState.value
            }, null, 8, ["current-state", "previous-state"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "section-title" }, "State Machine", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["state-badge", aiState.value])
            }, _toDisplayString(aiState.value), 3)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "key" }, "state", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value state-value", aiState.value])
              }, _toDisplayString(aiState.value), 3)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "key" }, "sessionId", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value", { null: !_unref(machine).sessionId }])
              }, _toDisplayString(_unref(machine).sessionId || "null"), 3),
              (_unref(machine).sessionId)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "copy-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard(_unref(machine).sessionId, 'sessionId'))),
                    title: copiedField.value === 'sessionId' ? 'Copied!' : 'Copy'
                  }, [
                    (copiedField.value !== 'sessionId')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("rect", {
                            x: "9",
                            y: "9",
                            width: "13",
                            height: "13",
                            rx: "2",
                            ry: "2"
                          }, null, -1),
                          _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                        ]))]))
                  ], 8, _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "key" }, "recorderUrl", -1)),
              (aiRecorderUrl.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: aiRecorderUrl.value,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "value url-value clickable-url",
                    title: aiRecorderUrl.value
                  }, [
                    _createTextVNode(_toDisplayString(truncateUrl(aiRecorderUrl.value)) + " ", 1),
                    _cache[12] || (_cache[12] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      width: "10",
                      height: "10",
                      class: "external-icon"
                    }, [
                      _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
                      _createElementVNode("polyline", { points: "15 3 21 3 21 9" }),
                      _createElementVNode("line", {
                        x1: "10",
                        y1: "14",
                        x2: "21",
                        y2: "3"
                      })
                    ], -1))
                  ], 8, _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, "null"))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "key" }, "locked", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", isLocked.value ? 'true' : 'false'])
              }, _toDisplayString(isLocked.value), 3)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "section-title" }, "Session Data", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", aiSessionData.value?.recorderSessionId ? 'active' : 'inactive'])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "key" }, "recorderSessionId", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value", { null: !aiSessionData.value?.recorderSessionId }])
              }, _toDisplayString(aiSessionData.value?.recorderSessionId || "null"), 3),
              (aiSessionData.value?.recorderSessionId)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "copy-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(aiSessionData.value.recorderSessionId, 'recorderSessionId'))),
                    title: copiedField.value === 'recorderSessionId' ? 'Copied!' : 'Copy'
                  }, [
                    (copiedField.value !== 'recorderSessionId')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("rect", {
                            x: "9",
                            y: "9",
                            width: "13",
                            height: "13",
                            rx: "2",
                            ry: "2"
                          }, null, -1),
                          _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                        ]))]))
                  ], 8, _hoisted_20))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "key" }, "licenseId", -1)),
              _createElementVNode("span", _hoisted_24, _toDisplayString(aiSessionData.value?.licenseId || "null"), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "key" }, "patientId", -1)),
              _createElementVNode("span", _hoisted_26, _toDisplayString(aiSessionData.value?.patientId || "null"), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "key" }, "hasSummaryData", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", !!aiSessionData.value?.summaryData ? 'true' : 'false'])
              }, _toDisplayString(!!aiSessionData.value?.summaryData), 3)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "section-title" }, "Templates", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", _unref(machine).templates.length > 0 ? 'active' : 'inactive'])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "key" }, "count", -1)),
              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(machine).templates.length), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "section-title" }, "Socket", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", socketConnected.value ? 'active' : 'inactive'])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "key" }, "connected", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", socketConnected.value ? 'true' : 'false'])
              }, _toDisplayString(socketConnected.value), 3)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _cache[26] || (_cache[26] = _createElementVNode("span", { class: "key" }, "reconnecting", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", isReconnecting.value ? 'true' : 'false'])
              }, _toDisplayString(isReconnecting.value), 3)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "section-title" }, "UI State", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", uiPopoverVisible.value || uiRecorderVisible.value ? 'active' : 'inactive'])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "key" }, "displayMode", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value", uiDisplayMode.value])
              }, _toDisplayString(uiDisplayMode.value), 3)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _cache[29] || (_cache[29] = _createElementVNode("span", { class: "key" }, "isMinimized", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", uiIsMinimized.value ? 'true' : 'false'])
              }, _toDisplayString(uiIsMinimized.value), 3)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "key" }, "showFab", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", uiShowFab.value ? 'true' : 'false'])
              }, _toDisplayString(uiShowFab.value), 3)
            ]),
            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "tree-item tree-separator" }, [
              _createElementVNode("span", { class: "key separator-label" }, "— Modals —")
            ], -1)),
            _createElementVNode("div", _hoisted_44, [
              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "key" }, "recorderVisible", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", uiRecorderVisible.value ? 'true' : 'false'])
              }, _toDisplayString(uiRecorderVisible.value), 3)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "key" }, "processingModal", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", uiProcessingModalVisible.value ? 'true' : 'false'])
              }, _toDisplayString(uiProcessingModalVisible.value), 3)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "key" }, "reviewModal", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", uiReviewModalVisible.value ? 'true' : 'false'])
              }, _toDisplayString(uiReviewModalVisible.value), 3)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "key" }, "popoverVisible", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", uiPopoverVisible.value ? 'true' : 'false'])
              }, _toDisplayString(uiPopoverVisible.value), 3)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "section-title" }, "Recovery Mode", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", _unref(isInRecoveryMode) ? 'warning' : 'inactive'])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _cache[37] || (_cache[37] = _createElementVNode("span", { class: "key" }, "active", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", _unref(isInRecoveryMode) ? 'true' : 'false'])
              }, _toDisplayString(_unref(isInRecoveryMode)), 3)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "key" }, "lastKnownStatus", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value", { null: !_unref(lastKnownStatus) }])
              }, _toDisplayString(_unref(lastKnownStatus) || "null"), 3)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "key" }, "showRefreshButton", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", _unref(showRefreshButton) ? 'true' : 'false'])
              }, _toDisplayString(_unref(showRefreshButton)), 3)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _cache[40] || (_cache[40] = _createElementVNode("span", { class: "key" }, "pollingFailCount", -1)),
              _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(pollingFailCount)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "section-title" }, "Session Lock", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", aiLockedSessionId.value ? 'active' : 'inactive'])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _cache[44] || (_cache[44] = _createElementVNode("span", { class: "key" }, "lockedSessionId", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value", { null: !aiLockedSessionId.value }])
              }, _toDisplayString(aiLockedSessionId.value || "null"), 3),
              (aiLockedSessionId.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "copy-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (copyToClipboard(aiLockedSessionId.value, 'lockedSessionId'))),
                    title: copiedField.value === 'lockedSessionId' ? 'Copied!' : 'Copy'
                  }, [
                    (copiedField.value !== 'lockedSessionId')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_61, [...(_cache[42] || (_cache[42] = [
                          _createElementVNode("rect", {
                            x: "9",
                            y: "9",
                            width: "13",
                            height: "13",
                            rx: "2",
                            ry: "2"
                          }, null, -1),
                          _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_62, [...(_cache[43] || (_cache[43] = [
                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                        ]))]))
                  ], 8, _hoisted_60))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_63, [
              _cache[45] || (_cache[45] = _createElementVNode("span", { class: "key" }, "isLocked", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", isLocked.value ? 'true' : 'false'])
              }, _toDisplayString(isLocked.value), 3)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _cache[46] || (_cache[46] = _createElementVNode("span", { class: "section-title" }, "Dev Settings", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", hasActiveDevSettings.value ? 'warning' : 'inactive'])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _cache[47] || (_cache[47] = _createElementVNode("span", { class: "key" }, "simulateSocketDisconnect", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", _unref(settings).simulateSocketDisconnect ? 'true' : 'false'])
              }, _toDisplayString(_unref(settings).simulateSocketDisconnect), 3)
            ]),
            _createElementVNode("div", _hoisted_68, [
              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "key" }, "simulatePollingTimeout", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value boolean", _unref(settings).simulatePollingTimeout ? 'true' : 'false'])
              }, _toDisplayString(_unref(settings).simulatePollingTimeout), 3)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["state-section history-section", { detached: _unref(isDetached) }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["section-header", { collapsible: !_unref(isDetached) }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (!_unref(isDetached) && (showHistory.value = !_unref(showHistory))))
          }, [
            _cache[52] || (_cache[52] = _createElementVNode("span", { class: "section-title" }, "State History", -1)),
            _createElementVNode("div", _hoisted_69, [
              (_unref(isDetached))
                ? (_openBlock(), _createElementBlock("span", _hoisted_70, "Detached"))
                : (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_unref(stateHistory).length), 1)),
              _createElementVNode("button", {
                class: "detach-btn",
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(toggleDetach) && _unref(toggleDetach)(...args)), ["stop"])),
                title: _unref(isDetached) ? 'Reattach to panel' : 'Detach to floating window'
              }, [
                (!_unref(isDetached))
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_73, [...(_cache[49] || (_cache[49] = [
                      _createElementVNode("path", { d: "M15 3h6v6" }, null, -1),
                      _createElementVNode("path", { d: "M10 14 21 3" }, null, -1),
                      _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }, null, -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_74, [...(_cache[50] || (_cache[50] = [
                      _createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }, null, -1),
                      _createElementVNode("polyline", { points: "16 17 21 12 16 7" }, null, -1),
                      _createElementVNode("line", {
                        x1: "21",
                        y1: "12",
                        x2: "9",
                        y2: "12"
                      }, null, -1)
                    ]))]))
              ], 8, _hoisted_72),
              (!_unref(isDetached))
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 2,
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    width: "12",
                    height: "12",
                    class: _normalizeClass(["chevron", { open: _unref(showHistory) }])
                  }, [...(_cache[51] || (_cache[51] = [
                    _createElementVNode("path", { d: "m9 18 6-6-6-6" }, null, -1)
                  ]))], 2))
                : _createCommentVNode("", true)
            ])
          ], 2),
          (!_unref(isDetached) && _unref(showHistory))
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                (_unref(stateHistory).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _createElementVNode("button", {
                        class: "clear-btn",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(clearHistory) && _unref(clearHistory)(...args)))
                      }, "Clear")
                    ]))
                  : _createCommentVNode("", true),
                (_unref(stateHistory).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, "No state changes recorded yet"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(stateHistory)].reverse(), (entry) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: entry.id,
                          class: "history-entry"
                        }, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("span", _hoisted_80, _toDisplayString(entry.source), 1),
                            _createElementVNode("span", _hoisted_81, "." + _toDisplayString(entry.key), 1),
                            _createElementVNode("span", _hoisted_82, _toDisplayString(_unref(formatHistoryTime)(entry.timestamp)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("span", _hoisted_84, _toDisplayString(_unref(formatValue)(entry.oldValue)), 1),
                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "arrow" }, "→", -1)),
                            _createElementVNode("span", _hoisted_85, _toDisplayString(_unref(formatValue)(entry.newValue)), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ], 2))
}
}

})